import axios from "axios";
const envInstance = axios.create();

export const getUrlApi = async (variavel) => {
  const resp = await envInstance.get('/env.json');
  return resp.data[variavel];
};

